// Multiplier slider + inline mini readout (used in Rules editor & Detail).

function meaningOf(v: number) {
  if (v < 0.4)  return "barely matters";
  if (v < 0.85) return "less than baseline";
  if (v <= 1.15) return "baseline importance";
  if (v < 2)    return "more than baseline";
  if (v < 3.5)  return "very important";
  return "critical signal";
}

interface SliderProps {
  value: number;
  onChange: (v: number) => void;
  min?: number; max?: number; step?: number;
}

export function MultSlider({
  value, onChange, min = 0.1, max = 5, step = 0.1,
}: SliderProps) {
  const pct = ((value - min) / (max - min)) * 100;
  const basePct = ((1 - min) / (max - min)) * 100;
  return (
    <div className="mult-control">
      <div className="mult-readout">
        <span className="num">{value.toFixed(1)}</span>
        <span className="x">×</span>
        <span className="label">{meaningOf(value)}</span>
      </div>
      <div className="mult-track">
        <div className="fill" style={{ width: pct + "%" }} />
        <div className="baseline" style={{ left: basePct + "%" }} />
        <input
          type="range" min={min} max={max} step={step} value={value}
          onChange={(e) => onChange(parseFloat(e.target.value))}
        />
      </div>
      <div className="mult-ticks">
        <span>0.1×</span>
        <span style={{ marginLeft: -8 }}>0.5×</span>
        <span style={{ flex: 0, color: "var(--ink)" }}>1×</span>
        <span>2×</span>
        <span>5×</span>
      </div>
    </div>
  );
}

interface MiniProps {
  value: number;
  failed?: boolean;
  min?: number; max?: number;
}

export function MultMini({ value, failed, min = 0.1, max = 5 }: MiniProps) {
  const pct = Math.max(0, ((value - min) / (max - min)) * 100);
  const basePct = ((1 - min) / (max - min)) * 100;
  const cls = "mult-mini" + (failed ? " failed" : (value < 1 ? " muted" : ""));
  return (
    <span className={cls}>
      <span className="num">{value.toFixed(1)}×</span>
      <span className="track">
        <span className="fill" style={{ width: pct + "%" }} />
        <span className="baseline" style={{ left: basePct + "%" }} />
      </span>
    </span>
  );
}
